import type { User } from '../../domain/user';
import { USER_SAM_ON_BOARDING_COMPLETED } from '../../domain/user';
import { queryClient } from '../../queryClient';
import { appStore } from '../../services/appStore';

import userQueryKey from './userQueryKey';

export const markOnboardingAsCompleted = () => {
  appStore.setIsFirstLoadingAfterOnboarding(true);
  queryClient.setQueryData(userQueryKey.userInfo(), (prev: User | undefined) => {
    if (!prev) {
      return;
    }
    return {
      ...prev,
      userSettings: {
        ...prev.userSettings,
        [USER_SAM_ON_BOARDING_COMPLETED]: true,
      },
    };
  });
};
